import ServerAxios from "../api/serverAxios";

const getDefaultPortal = () => ({
  client: null,
  subClient: null,
  stage: null,
});

ServerAxios.interceptors.response.use(
  (response) => {
    try {
      const portalHeader =
        response.headers["x-portal-context"] ||
        response.headers["X-Portal-Context"];

      if (!portalHeader) return response;

      const portal = JSON.parse(portalHeader);

      //  only store if valid 
      if (portal?.client || portal?.subClient || portal?.stage) {
        (window as any).__PORTAL__ = portal;
      }
    } catch (e) {
      console.warn("Failed to parse portal header", e);
    }

    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);